import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import ReactModal from "react-modal";
import Header from "components/Headers/Header";
import { Editor } from "@tinymce/tinymce-react";
import Cookies from "universal-cookie";
import Swal from "sweetalert2";
import ComentariosVisualizacion from "./ComentarioVisualizacion";

const Pruebas = (props) => {
  const cookie = new Cookies();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [editModalIsOpen, setEditModalIsOpen] = useState(false);
  const [htmlContent, setHtmlContent] = useState("");
  const [isHtmlLoaded, setIsHtmlLoaded] = useState(false);
  const editorRef = useRef(null);

  const handleOpenModalTest = () => setIsOpen(true);
  const closeModal = () => {
    setIsOpen(false);
    setIsHtmlLoaded(false);
  };

  const handleOpenEditModal = () => setEditModalIsOpen(true);
  const closeEditModal = () => setEditModalIsOpen(false);

  const fetchHtmlContent = async () => {
    try {
      const response = await axios.get(
        "https://contratosback-dev.azurewebsites.net/api/v1/ObtenerContrato/" +
          props.id
      );

      const contenido = response.data;

      if (!contenido || contenido.trim() === "") {
        Swal.fire({
          icon: "warning",
          title: "Contrato no disponible",
          text: "Asegúrese de que el contrato haya sido generado.",
          confirmButtonText: "Aceptar",
          willOpen: zIndexFix,
        });
        return;
      }

      setHtmlContent(contenido);
      setIsHtmlLoaded(true);
    } catch (error) {
      console.error("Error fetching HTML content", error);
      Swal.fire({
        icon: "info",

        text: "No se encontro el contrato, Asegurese de que el contrato haya sido generado",
        confirmButtonText: "Aceptar",
        willOpen: zIndexFix,
      });
    }
  };

  const zIndexFix = () => {
    setTimeout(() => {
      const container = document.querySelector(".swal2-container");
      const popup = document.querySelector(".swal2-popup");
      if (container) container.style.zIndex = "9999";
      if (popup) popup.style.zIndex = "10000";
    }, 50);
  };

  const handleSaveChanges = async () => {
    try {
      const response = await axios.put(
        `https://contratosback-dev.azurewebsites.net/api/v1/ActualizaContratos/${props.id}`,
        { textoContrato: htmlContent }
      );

      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "¡Éxito!",
          text: "Contrato actualizado correctamente.",
          willOpen: zIndexFix,
          confirmButtonText: "Aceptar",
        }).then(() => {
          closeEditModal();
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Error al actualizar el contrato.",
          willOpen: zIndexFix,
        });
      }
    } catch (error) {
      console.error("Error al guardar los cambios", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al intentar guardar los cambios.",
        willOpen: zIndexFix,
      });
    }
  };

  // 📄 Generar PDF con html2pdf.js

  useEffect(() => {
    document.body.style.overflow =
      editModalIsOpen || modalIsOpen ? "hidden" : "auto";
  }, [editModalIsOpen, modalIsOpen]);

  // 🧱 Fix para menús de TinyMCE encima de modales
  useEffect(() => {
    if (editModalIsOpen) {
      const style = document.createElement("style");
      style.innerHTML = `
        .tox { z-index: 3000 !important; }
        .tox-dialog { z-index: 4000 !important; }
        .tox-editor-container { z-index: 3000 !important; }
      `;
      document.head.appendChild(style);
      return () => {
        document.head.removeChild(style);
      };
    }
  }, [editModalIsOpen]);
  const [estadoPanel, setEstadoPanel] = useState("normal"); // puede ser "normal", "visual", "comentarios"
  const manejarExpandir = () => {
    if (estadoPanel === "normal") setEstadoPanel("visual");
    else if (estadoPanel === "visual") setEstadoPanel("comentarios");
    else setEstadoPanel("normal");
  };

  const textoBoton =
    estadoPanel === "normal"
      ? "Expandir documento ▶"
      : estadoPanel === "visual"
      ? "Expandir comentarios ◀"
      : "Restaurar↔";

  return (
    <div>
      <button
        className="btn btn-danger btn-lg"
        onClick={handleOpenModalTest}
        style={{ padding: "10px 10px", fontSize: "13px" }}
      >
        Visualizar contrato
      </button>

      {/* Modal de previsualización */}
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Previsualización del Contrato"
        style={{ overlay: { zIndex: 2000 } }}
      >
        <button
          onClick={closeModal}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            background: "#a4a5a5",
            color: "white",
            border: "none",
            borderRadius: "50%",
            width: "70px",
            height: "70px",
            fontSize: "16px",
            fontWeight: "bold",
            cursor: "pointer",
            zIndex: 3000,
          }}
        >
          cerrar
        </button>

        <Header />

        <button className="btn btn-primary btn-lg" onClick={fetchHtmlContent}>
          Previsualizar el documento
        </button>

        <hr />
        {/* Editor TinyMCE (solo lectura) */}
        {(cookie.get("tipo_Usuario") == "4" ||
          cookie.get("tipo_Usuario") == "1") && (
          <div style={{ marginTop: "16px", textAlign: "right" }}>
            <button
              className="btn btn-info btn-lg"
              onClick={handleOpenEditModal}
              disabled={!isHtmlLoaded}
            >
              Editar Contrato
            </button>
          </div>
        )}
        {isHtmlLoaded && (
          <>
            {/* Botón de expansión arriba de los paneles */}
            <div className="text-center mb-3" style={{ zIndex: 3000 }}>
              <button
                className="btn btn-outline-primary btn-lg"
                onClick={manejarExpandir}
              >
                {textoBoton}
              </button>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                height: "80vh",
                gap: "10px",
                transition: "all 0.3s ease",
              }}
            >
              {/* Panel izquierdo: Editor */}
              <div
                style={{
                  flex:
                    estadoPanel === "visual"
                      ? 9
                      : estadoPanel === "comentarios"
                      ? 2
                      : 6,
                  transition: "all 0.3s ease",
                  overflow: "hidden",
                }}
              >
                <Editor
                  value={htmlContent}
                  init={{
                    height: 500,
                    menubar: true,
                    readonly: 1,
                    plugins: ["print"],
                    toolbar: "print",
                    content_style:
                      "body { font-family:Helvetica,Arial,sans-serif; font-size:14px; line-height:1.6; }",
                  }}
                  tinymceScriptSrc="https://cdn.tiny.cloud/1/dctsy3q1ism8sxejyno01cv605iqzbpyoggz0najurqlvcki/tinymce/6/tinymce.min.js"
                />
              </div>

              {/* Panel derecho: Comentarios */}
              <div
                style={{
                  flex:
                    estadoPanel === "comentarios"
                      ? 9
                      : estadoPanel === "visual"
                      ? 2
                      : 6,
                  transition: "all 0.3s ease",
                  overflow: "hidden",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <ComentariosVisualizacion id={props.id} />
              </div>
            </div>
          </>
        )}
      </ReactModal>

      {/* Modal de edición con TinyMCE */}
      <ReactModal
        isOpen={editModalIsOpen}
        onRequestClose={closeEditModal}
        contentLabel="Editar Contrato"
        style={{
          overlay: { zIndex: 2000 },
          content: { inset: "50px", overflow: "auto" },
        }}
        shouldFocusAfterRender={false}
      >
        {isHtmlLoaded && (
          <>
            <Editor
              key={editModalIsOpen}
              apiKey="dctsy3q1ism8sxejyno01cv605iqzbpyoggz0najurqlvcki"
              onInit={(evt, editor) => (editorRef.current = editor)}
              value={htmlContent}
              onEditorChange={(newContent) => setHtmlContent(newContent)}
              init={{
                height: 500,
                menubar: true,
                paste_data_images: true,
                autofocus: false,
                plugins: [
                  "advlist autolink lists link image charmap print preview anchor",
                  "searchreplace visualblocks code fullscreen",
                  "insertdatetime media table paste code help wordcount",
                ],
                toolbar:
                  "undo redo | formatselect | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | image table | removeformat | help",
                setup: (editor) => {
                  editor.on("focus", (e) => e.stopImmediatePropagation());
                  editor.on("init", () => {
                    const container = editor.getContainer();
                    if (container) {
                      container.addEventListener("focusin", (e) => {
                        e.stopPropagation();
                      });
                    }
                  });
                },
              }}
            />
          </>
        )}

        <button className="btn btn-primary btn-lg" onClick={handleSaveChanges}>
          Guardar Cambios
        </button>
      </ReactModal>
    </div>
  );
};

export default Pruebas;
